import { isRealSection } from "../types/Data";
import { useCustomParams } from "./useCustomParams";

/**
 * Checks whether current page is an article page.
 */
export const useIsArticlePage = () => {
  const { level1 = "", level2 = "" } = useCustomParams();

  const regexMatchArticle = /^story(?:[0-9]+)?-[0-9]+$/; // web2 & drupal articles
  const regexMatchArticlePreview = /^article[0-9]+ece$/; // preview

  return (
    isRealSection(level1) &&
    level2 &&
    (regexMatchArticle.test(level2) || regexMatchArticlePreview.test(level2))
  );
};
